import { Box, Text } from '@chakra-ui/react';

export const StackPreview = () => {
  return (
    <Box>
      <Text>StackPreview - Coming soon</Text>
    </Box>
  );
};
